import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { IconButton } from "@mui/material";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { useTheme } from "@emotion/react";
import MenuItem from "@mui/material/MenuItem";
import { NavLink } from "react-router";

const pages = [
  { name: "About me", key: "aboutme", path: "/" },
  { name: "Projects", key: "projects", path: "projects" },
  { name: "Contacts", key: "contacts", path: "contacts" },
];

function Navbar() {
  const theme = useTheme();

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position="static"
      sx={{ bgcolor: "navbarFooter.main" }}
      color="inherit"
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h4"
            noWrap
            component="a"
            sx={{
              mr: 10,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Vlad K
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              onClick={handleOpenNavMenu}
              aria-label="Navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
              sx={{
                width: 48,
                height: 48,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="40px"
                viewBox="0 -960 960 960"
                width="40px"
                fill="#2C2C2C"
              >
                <path
                  d="M120-240v-66.67h720V-240H120Zm0-206.67v-66.66h720v66.66H120Zm0-206.66V-720h720v66.67H120Z"
                  fill={theme.palette.paperBorder.main}
                />
              </svg>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <NavLink
                  to={page.path}
                  style={{ textDecoration: "inherit", color: "inherit" }}
                  key={page.key}
                >
                  {({ isActive }) => (
                    <MenuItem
                      key={page.key}
                      onClick={handleCloseNavMenu}
                      sx={
                        isActive
                          ? { color: theme.palette.primary.main }
                          : { color: theme.palette.paperBorder.main }
                      }
                    >
                      <Typography sx={{ textAlign: "center" }}>
                        {page.name}
                      </Typography>
                    </MenuItem>
                  )}
                </NavLink>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 5,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Vlad K
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <NavLink
                to={page.path}
                style={{ textDecoration: "inherit", color: "inherit" }}
                key={page.key}
              >
                {({ isActive }) => (
                  <Button
                    key={page.key}
                    variant={isActive ? "contained" : "outlined"}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: "inherit", display: "block", mr: 3 }}
                  >
                    {page.name}
                  </Button>
                )}
              </NavLink>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
